import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    id: 0,
    isLogged: false,
    role_id: 0,
    user: {
      username: "",
      email: "",
      avatar: "",
      id: null,
      role_id: 0,
      order_invoice_codes: [],
      ask_for_verification: 0,
    },
    userGames: [],
    unread_notifications: 0,
    unread_messages: 0,
    utm: {},
    is_utm_user: false,
  }),
  getters: {
    getUser: (state) => state.user,
    getUnreadNotifications: (state) => state.unread_notifications,
    getUnreadMessage: (state) => state.unread_messages,
    getUserLoggedIn: (state) => state.isLogged,
    getUserCurrency: (state) => state?.user?.currency || 1,
    getUserCurrencyCode: (state) => {
      const currency = state?.user?.currency || 1;
      switch (currency) {
        case 1:
          return "$";
        case 2:
          return "€";
        case 3:
          return "£";
        case 4:
          return "€";
        case 5:
          return "A$";
        case 6:
          return "C$";
        case 7:
          return "S$";
        default:
          return "$";
      }
    },
    getUserCurrencyAbr: (state) => {
      const currency = state?.user?.currency || 1;
      switch (currency) {
        case 1:
          return "USD";
        case 2:
          return "EUR";
        case 3:
          return "GBP";
        case 4:
          return "AED";
        case 5:
          return "AUD";
        case 6:
          return "CAD";
        case 7:
          return "SGD";
        default:
          return "USD";
      }
    },
    getUserGames: (state) => state.userGames,
    getUtmChanged: (state) => {
      const isFirstLoaded = state.utm.utm_first_load;

      const hasChanged =
        isFirstLoaded ||
        Object.entries(state.utm).some(([key, value]) => {
          if (
            !key.startsWith("initial_") &&
            key !== "utm_first_load" &&
            value
          ) {
            const initialValue = state.utm[`initial_${key}`] ?? null;
            return (value || null) !== initialValue;
          }
          return false;
        });
      return hasChanged
        ? {
            utm_source: state.utm.utm_source,
            utm_medium: state.utm.utm_medium,
            utm_campaign: state.utm.utm_campaign,
            utm_content: state.utm.utm_content,
            utm_term: state.utm.utm_term,
            utm_id: state.utm.utm_id,
            utm_campaign_id: state.utm.utm_campaign_id,
            utm_source_platform: state.utm.utm_source_platform,
            utm_creative_format: state.utm.utm_creative_format,
            utm_marketing_tactic: state.utm.utm_marketing_tactic,
            initial_utm_source: state.utm.initial_utm_source,
            initial_utm_medium: state.utm.initial_utm_medium,
            initial_utm_campaign: state.utm.initial_utm_campaign,
            initial_utm_content: state.utm.initial_utm_content,
            initial_utm_term: state.utm.initial_utm_term,
            initial_utm_id: state.utm.initial_utm_id,
            initial_utm_campaign_id: state.utm.initial_utm_campaign_id,
            initial_utm_source_platform: state.utm.initial_utm_source_platform,
            initial_utm_creative_format: state.utm.initial_utm_creative_format,
            initial_utm_marketing_tactic:
              state.utm.initial_utm_marketing_tactic,
          }
        : {};
    },
    getUtm: (state) => {
      if (!state.is_utm_user) return {};
      return {
        utm_source: state.utm.utm_source,
        utm_medium: state.utm.utm_medium,
        utm_campaign: state.utm.utm_campaign,
        utm_content: state.utm.utm_content,
        utm_term: state.utm.utm_term,
        utm_id: state.utm.utm_id,
        utm_campaign_id: state.utm.utm_campaign_id,
        utm_source_platform: state.utm.utm_source_platform,
        utm_creative_format: state.utm.utm_creative_format,
        utm_marketing_tactic: state.utm.utm_marketing_tactic,
      };
    },
    isSecondaryCS: (state) => {
      if (state.user.secondary_role_id === 6 && state.user.role_id === 4) {
        return true;
      }
      return false;
    },
  },
  actions: {
    setUnreadnotifications(payload) {
      this.$state.unread_notifications = payload;
    },
    setUnreadMessages(payload) {
      this.$state.unread_messages = payload;
    },
    setItmUser(payload) {
      this.$patch({
        is_utm_user: true,
      });
    },
    setUtmData(payload) {
      this.$patch({
        utm: {
          ...payload,
        },
      });
    },

    async refetchUnreadMessages(payload) {
      try {
        const { getLocale } = useFunctions();
        const { data } = await useApiPost("/api/get-unread-chats", {
          method: "POST",
          body: {
            locale: getLocale(),
          },
        });
        if (data?.count_of_unread >= 0) {
          this.setUnreadMessages(data?.count_of_unread);
        }
      } catch (error) {
        // console.log(error);
      }
    },
    setUser(payload) {
      const { public: publicConfig } = useRuntimeConfig();
      this.$patch({
        user: {
          ...payload,
        },
        isLogged: true,
      });
    },

    logOutUser(payload) {
      const { public: publicConfig } = useRuntimeConfig();
      if (publicConfig.nuxtEnv === "prod") {
      }
      this.$patch({
        user: {},
        isLogged: false,
        unread_messages: 0,
        unread_notifications: 0,
      });
      this.$patch({
        user: {
          username: "",
        },
      });
    },

    appendInfo(payload) {
      this.$patch({
        user: {
          ...this.$state.user,
          ...payload,
        },
      });
    },

    async fetchUserGames() {
      try {
        const { data: response } = await useApiFetch("/api/get-user-games", {
          method: "POST",
          fetchKey: "user-games",
        });

        if (response.value?.data) {
          this.$patch({
            userGames: response.value?.data,
          });
        }
      } catch (error) {
        console.log("error", JSON.stringify(error));
      }
    },

    async fetchUser() {
      try {
        const { public: publicConfig } = useRuntimeConfig();
        const { data: response } = await useApiPost("/api/me", {
          method: "GET",
        });

        if (response) {
          this.$patch({
            user: {
              ...response,
            },
            isLogged: true,
          });
        }
      } catch (error) {
        // console.log(error);
      }
    },
  },
});
